import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticatedGuard } from 'routes/routes.guard';
import { RoutePaths, RouteRoles } from './route.roles';

const routes: Routes = [
    // {
    //     path: RoutePaths.Home,
    //     loadChildren: () => import('../modules/home/home.module').then((m) => m.HomeModule),
    // },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: RoutePaths.Landing, // Update as needed
    },
    {
        path: RoutePaths.StaffSSO,
        loadChildren: () => import('../modules/staffSSO/staffSSO.module').then((m) => m.StaffSSOModule),
    },
    {
        path: `${RoutePaths.Offline}`,
        loadChildren: () => import('../modules/offline/offline.module').then((m) => m.OfflineModule),
    },
    {
        path: `${RoutePaths.ConfirmAccount}`,
        loadChildren: () => import('../modules/confirm-account/confirm-account.module').then((m) => m.ConfirmAccountModule),
    },
    {
        path: `${RoutePaths.ConfirmAccount2}`,
        loadChildren: () => import('../modules/confirm-account/confirm-account.module').then((m) => m.ConfirmAccountModule),
    },
    {
        path: `${RoutePaths.PasswordReset}`,
        loadChildren: () => import('../modules/password-reset/password-reset.module').then((m) => m.PasswordResetModule),
    },
    {
        path: `${RoutePaths.PasswordReset2}`,
        loadChildren: () => import('../modules/password-reset/password-reset.module').then((m) => m.PasswordResetModule),
    },
    {
        path: `${RoutePaths.Landing}`,
        loadChildren: () => import('../modules/landing/landing.module').then((m) => m.LandingModule),
        data: { url: document.location.href },
    },
    {
        path: `${RoutePaths.Home}`,
        loadChildren: () => import('../modules/home/home.module').then((m) => m.HomeModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.PCPSConnect}`,
        loadChildren: () => import('../modules/pcpsconnect/pcpsconnect.module').then((m) => m.PCPSConnectModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.Interviews}`,
        loadChildren: () => import('../modules/interviews/interviews.module').then((m) => m.InterviewsModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.JobBrowser}`,
        loadChildren: () => import('../modules/job-browser/job-browser.module').then((m) => m.JobBrowserModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.Transcripts}`,
        loadChildren: () => import('../modules/application/transcripts/transcripts.module').then((m) => m.TranscriptsModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.ApplicationStatus}`,
        loadChildren: () => import('../modules/application/status/status.module').then((m) => m.ApplicationStatusModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.PersonalInfo}`,
        loadChildren: () => import('../modules/application/personal/personal.module').then((m) => m.PersonalInfoModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.ContactInfo}`,
        loadChildren: () => import('../modules/application/contact/contact.module').then((m) => m.ContactInfoModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.ApplicationType}`,
        loadChildren: () => import('../modules/application/apptype/apptype.module').then((m) => m.ApplicationTypeModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.EducationHistory}`,
        loadChildren: () => import('../modules/application/edhistory/edhistory.module').then((m) => m.EducationHistoryModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.EmploymentHistory}`,
        loadChildren: () =>
            import('../modules/application/employment-history/employment-history.module').then((m) => m.EmploymentHistoryModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.WorkPerformance}`,
        loadChildren: () =>
            import('../modules/application/work-performance/work-performance.module').then((m) => m.WorkPerformanceModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.References}`,
        loadChildren: () => import('../modules/application/references/references.module').then((m) => m.ReferencesModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.CriminalHistory}`,
        loadChildren: () =>
            import('../modules/application/criminal-history/criminal-history.module').then((m) => m.CriminalHistoryModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.ApplicantSurvey}`,
        loadChildren: () =>
            import('../modules/application/applicant-survey/applicant-survey.module').then((m) => m.ApplicantSurveyModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.ProfessioanlQualifications}`,
        loadChildren: () =>
            import('../modules/application/prof-qualifications/prof-qualifications.module').then((m) => m.ProfQualificationsModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.Certification}`,
        loadChildren: () => import('../modules/application/certification/certification.module').then((m) => m.CertificationModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.InstructionalQualifications}`,
        loadChildren: () =>
            import('../modules/application/inst-qualifications/inst-qualifications.module').then((m) => m.InstQualificationsModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.Sanctions}`,
        loadChildren: () => import('../modules/application/sanctions/sanctions.module').then((m) => m.SanctionsModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.SubjectAreaExams}`,
        loadChildren: () =>
            import('../modules/application/subject-area-exams/subject-area-exams.module').then((m) => m.SubjectAreaExamsModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.SubjectAreaInterest}`,
        loadChildren: () =>
            import('../modules/application/subject-area-interest/subject-area-interest.module').then(
                (m) => m.SubjectAreaInterestModule
            ),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.StudentTeaching}`,
        loadChildren: () =>
            import('../modules/application/student-teaching/student-teaching.module').then((m) => m.StudentTeachingModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.ParaSurvey}`,
        loadChildren: () => import('../modules/application/para-survey/para-survey.module').then((m) => m.ParaSurveyModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.CustodialSurvey}`,
        loadChildren: () =>
            import('../modules/application/custodial-survey/custodial-survey.module').then((m) => m.CustodialSurveyModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.TeacherTransfer}`,
        loadChildren: () =>
            import('../modules/application/teacher-transfer/teacher-transfer.module').then((m) => m.TeacherTransferModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: `${RoutePaths.ResumesCoverLetters}`,
        loadChildren: () => import('../modules/application/resumes/resumes.module').then((m) => m.ResumesCoverLettersModule),
        canActivate: [AuthenticatedGuard],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
